import "chosen-js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle(
  "vendors@template.addresses@template.blog@template.collection@template.product",
);
